<template>
<div>
     <div class="menu w-96 h-full">
           <router-link to="/pwd">
        <div class="menu1  h-20  float-left mt-4 ml-4 flex justify-center items-center  cursor-pointer active:bg-yellow-700" >
         <p>修改登录密码</p>
        </div>
</router-link>
    </div><!--left-->

</div>
<router-view/>
</template>
<script>
export default {

}
</script>
<style scoped>
.menu1{
    background-color: #FF9900;
    color:#FFFFFF;
    font-size:1.5rem;
     width:21rem;
}
</style>
